import React, { Component, useEffect, useState } from 'react';
import { withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import AddOnPopupWithoutGrouping from './addOnPopupWithoutGrouping';
import { sendAnalytics } from '../../../../action/homeAction';
import { getDefaultAnalyticsLabel } from '../../../JS/utility';
import AddOnPopupWithGrouping from './addOnPopupWithGrouping';

export const AddOnPopup = (props) => {

    const [addOnGroupingTrue, setAddOnGrouping] = useState(false);


    useEffect(() => {


        if(props.addOnGroupTypeInfo.length > 0){
            setAddOnGrouping(true);
        }

        
        if (localStorage.getItem("addonEventSent") !== "true") {
            // Send Analytics
            let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
            props.sendAnalytics(
                props.guestDetail,
                props.currentWidgets.widgetType,
                "ADD ON POPUP",
                { ...label, "layoutTab": props.currentHomePage.tabName, "element": "widget", "widgetSessionId": localStorage.getItem("hcommerceSessionToken"), pageName: props.pageName, storeName: props.storeInfo.storeName },
                0,
                props.guestIsLoggedIn,
                () => localStorage.setItem("addonEventSent", true)
            );
            //
        }
    }, [])


    return (
        addOnGroupingTrue ? 
            <AddOnPopupWithGrouping 
                pageName={props.pageName} 
                addOn={props.addOn} 
                selectedAddOn={props.selectedAddOn} 
                backBtn={props.backBtn} 
                addOnCheckBoxCLick={props.addOnCheckBoxCLick}
                addToMyOrder={props.addToMyOrder}
            /> : 
            <AddOnPopupWithoutGrouping 
                pageName={props.pageName} 
                addOn={props.addOn} 
                selectedAddOn={props.selectedAddOn} 
                backBtn={props.backBtn} 
                addOnCheckBoxCLick={props.addOnCheckBoxCLick}
                addToMyOrder={props.addToMyOrder}
            />
    );
}

const mapStateToProps = state => {
    return {
        guestDetail: state.store.home.guestDetails,
        addOnGroupTypeInfo: state.store.Hcommerce.addOnGroupTypeInfo,
        storeInfo: state.store.Hcommerce.storeInfo,
        installedAppVersion: state.store.installedAppVersion,
        installedAppBuildNo: state.store.installedAppBuildNo,
        currentHomePage: state.store2.currentHomePage,
        currentWidgets: state.store.sideNavBar.currentWidget,
        guestIsLoggedIn: state.store2.guestIsLoggedIn,
    }
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(AddOnPopup));